<template>
    <div class="contents">
        <div class="headTab">
            <el-menu  mode="horizontal" class="clearfix" active-text-color="#8989ba" router :default-active="$route.path" >
                <el-menu-item index="/Finance/flowBill" class="floatL">Statement</el-menu-item>
                <el-menu-item index="/Finance/bill" class="floatL">Billing</el-menu-item>
                <el-menu-item index="/Finance/rechargeOrder" class="floatL">Transaction</el-menu-item>
                <el-menu-item index="/Finance/myPrice" class="floatL">My price</el-menu-item>
            </el-menu>
            
        </div>
        <router-view/>
    </div>
</template>
<script>
export default {
    data(){
        return {
            
        }
    }
}
</script>
<style scoped>
    .contents{
        margin: 20px;
        padding: 0 30px;
    }
    .floatL{
        float: left;
    }
    .floatR{
        float: right;
    }
    .clearfix{
        overflow:hidden;
        _zoom:1;
    }
    .contents .headTab{
        width: 400px;
    }
    .headTab .el-menu--horizontal>.el-menu-item{
        line-height: 40px;
        height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/components/views/Finance/Finance.vue